<template>
  <div class="comp-xl-date-variable my-variable-dropdown">
    <!-- 此处添加props.record?.condition的判断，是因为线索池自动回收规则组件中使用的是condition，其他组件都是operation-->
    <template v-if="props.record?.operation != 'between' && props.record?.condition != 'between' && props.record?.operation != 'null' && props.record?.operation != 'not_null' && props.record?.condition != 'null' && props.record?.condition != 'not_null'">
      <jw-dropdown @select="changeDateVariable($event, 1)" :popup-visible="data.isPop" :hideOnSelect="data.popupVisible" :popup-max-height="false" position="bl" content-class="search-ultra-filter-select">
        <jw-input-tag :model-value="data.dateVariable" style="width: 100%" :placeholder="$t('请选择日期')" :max-tag-count="1" @remove="removeDateVariable" :class="tagClassName || 'date-tag-input-default'" @click.stop="handleBlur" @press-enter="pressEnter" />
        <template #content>
          <div class="my-variable-dropdown-not-between">
            <template v-for="item in dateVariableList" :key="item.value">
              <div class="my-variable-dropdown">
                <jw-doption v-if="![1, 5, 6]?.includes(item.value) && canSelectMore" :value="item.value"> {{ item.label }}</jw-doption>
                <jw-dsubmenu v-if="item.value === 1" :value="item.value">
                  <span>指定日期</span>
                  <template #content>
                    <div class="my-variable-dropdown">
                      <jw-date-picker @change="changeDatePicker" :popup-visible="data.pickerVisible" :time-picker-props="{ defaultValue: '00:00:00' }" v-model="data.pickerValue" :format="props.objList?.fieldType != 21 ? props.objList?.fieldExt : props.objList?.business?.fieldExt" :show-time="isShowTime(props.record)" hide-trigger :style="{ width: isShowTime(props.record) ? '330px' : '268px', border: 'none' }" unmount-on-close @ok="changeDatePicker" />
                    </div>
                  </template>
                </jw-dsubmenu>

                <template v-if="canSelectMore">
                  <jw-doption v-if="item.value == 5" :value="5">
                    <span @click="dateOverlayFun">过去第</span>
                    <jw-input-number v-model="data.lastDay" hide-button size="mini" :style="{ width: '50px', margin: '0 3px' }" placeholder="请输入" :default-value="1" :step="1" @change="changeLastDay($event, 1)" :min="1" :precision="0" />
                    <span>天</span>
                  </jw-doption>
                  <jw-doption v-if="item.value == 6" :value="6">
                    <span @click="dateOverlayFun">未来第</span>
                    <jw-input-number v-model="data.nextDay" hide-button size="mini" :style="{ width: '50px', margin: '0 3px' }" placeholder="请输入" :default-value="1" :step="1" @change="changeNextDay($event, 1)" :min="1" :precision="0" />
                    <span>天</span>
                  </jw-doption>
                </template>
              </div>
            </template>
          </div>
        </template>
      </jw-dropdown>
    </template>
    <template v-else-if="props.record?.operation == 'between' || props.record?.condition == 'between'">
      <jw-dropdown @select="changeDateVariable($event, 2)" :popup-visible="data.isPop" :hideOnSelect="data.popupVisible" class="drop-down-date-range-picker" :popup-max-height="false" position="bl" content-class="search-ultra-filter-select">
        <jw-input-tag :model-value="data.dateVariable" style="width: 100%" :placeholder="$t('请选择日期范围')" :max-tag-count="1" @remove="removeDateVariable" :class="tagClassName || 'date-tag-input-default'" @click.stop="handleBlur" @press-enter="pressEnter" />
        <template #content>
          <div class="my-variable-dropdown-wrapper">
            <template v-for="item in dateRangeVariableList" :key="item.value">
              <div class="my-variable-dropdown">
                <jw-doption v-if="![7, 20, 21]?.includes(item.value) && canSelectMore" :value="item.value"> {{ item.label }}</jw-doption>
                <jw-dsubmenu v-if="item.value === 7" :value="item.value">
                  <span>指定日期</span>
                  <template #content>
                    <div class="my-variable-dropdown">
                      <jw-range-picker @change="changeDateRangePicker" v-model="data.pickerRangeValue" type="time-range" :popup-visible="data.pickerVisible" :format="props?.objList?.fieldType != 21 ? props?.objList?.fieldExt : props?.objList?.business?.fieldExt" :show-time="isShowTime(props.record)" :trigger-props="{ updateAtScroll: true }" position="br" :time-picker-props="{ defaultValue: ['00:00:00', '23:59:59'] }" hide-trigger style="width: 536px; border: none" unmount-on-close @ok="changeDateRangePicker" />
                    </div>
                  </template>
                </jw-dsubmenu>

                <template v-if="canSelectMore">
                  <jw-doption v-if="item.value == 20" :value="20">
                    <span @click="dateOverlayFun">过去</span>
                    <jw-input-number v-model="data.lastDay" hide-button size="mini" :style="{ width: '50px', margin: '0 3px' }" placeholder="请输入" :default-value="1" :step="1" @change="changeLastDay($event, 2)" :min="1" :precision="0" />
                    <span @click="dateOverlayFun">天内</span>
                  </jw-doption>
                  <jw-doption v-if="item.value == 21" :value="21">
                    <span @click="dateOverlayFun">未来</span>
                    <jw-input-number v-model="data.nextDay" hide-button size="mini" :style="{ width: '50px', margin: '0 3px' }" placeholder="请输入" :default-value="1" :step="1" @change="changeNextDay($event, 2)" :min="1" :precision="0" />
                    <span @click="dateOverlayFun">天内</span>
                  </jw-doption>
                </template>
              </div>
            </template>
          </div>
        </template>
      </jw-dropdown>
    </template>
    <div style="width: 200px" v-else-if="props.record?.operation == 'null' || props.record?.operation == 'not_null' || props.record?.condition == 'null' || props.record?.condition == 'not_null'"></div>
    <div v-if="dateOverlay" @click="dateOverlayFun" class="date-overlay"></div>
  </div>
</template>

<script setup>
import { computed, reactive, ref, watch } from 'vue';
import { tools } from '@/utils/tools';
import dayjs from 'dayjs';
console.log('1-开始创建组件-setup');
const props = defineProps({
  objList: {
    type: Object,
    default() {
      return {};
    }
  },
  record: {
    type: Object,
    default: () => {}
  },
  tagClassName: {
    type: String,
    default: 'date-tag-input-default'
  },
  canSelectMore: {
    type: Boolean,
    default: true
  }
});
console.log(43, props);
const dateOverlay = ref(false);
const dateShow = computed(() => (tools.isJSON(props.record?.value) ? JSON.parse(props.record.value) : props.record.value));
console.log(80, dateShow.value);
const emits = defineEmits(['cb']);
const data = reactive({
  lastDay: 1,
  nextDay: 1,
  isPop: false,
  popupVisible: false, //dropdown是否展示
  pickerVisible: false, //指定日期面板值是否展示
  dateVariable: dateShow.value ? dateShow.value.dateVariable : [],
  pickerValue: dateShow.value && typeof dateShow.value.value === 'string' ? ([1, 7].includes(dateShow.value.type) ? dateShow.value.value : null) : dayjs(Date.now()).format('YYYY-MM-DD 00:00:00'), //双向绑定的值
  pickerRangeValue: dateShow.value && Object.prototype.toString.call(dateShow.value.value) === '[object Object]' ? ([1, 7].includes(dateShow.value.type) ? [dateShow.value.value.beginDate, dateShow.value.value.endDate] : null) : [dayjs(Date.now()).format('YYYY-MM-DD 00:00:00'), dayjs(Date.now()).format('YYYY-MM-DD 23:59:59')] //双向绑定的值
});
const dateOverlayFun = () => {
  data.isPop = false;
  dateOverlay.value = false;
};
// 是否展示时间
const isShowTime = (item) => {
  const ext = item?.setting?.fieldType != 21 ? props.objList?.fieldExt : props.objList?.business?.fieldExt;
  if (!ext) return false;
  if (ext?.includes('HH:mm') || ext?.includes('HH:mm:ss') || ext?.includes('hh:mm')) {
    return true;
  } else {
    return false;
  }
};

const pressEnter = (v, e) => {
  console.log('pressEnter', v, e);
  e.stopPropagation();
};

const variableDropdown = (event) => {
  const target = event.target;
  const divs = document.getElementsByClassName('my-variable-dropdown');
  for (let i = 0; i < divs.length; i++) {
    if (divs[i]?.contains(target)) {
      console.log('内');
      return;
    }
  }
  // data.isPop = false;
};
//监听事件
import useEventListener from '@/hooks/event-listener';
const { eventListener } = useEventListener();
eventListener('click', variableDropdown, document);
// 日期变量的选项值list
const dateVariableList = ref([
  {
    label: '指定日期',
    value: 1
  },
  {
    label: '今天',
    value: 2
  },
  {
    label: '昨天',
    value: 3
  },
  {
    label: '明天',
    value: 4
  },
  {
    label: `过去第${data.lastDay}天`,
    value: 5
  },
  {
    label: `未来第${data.nextDay}天`,
    value: 6
  }
]);
// 日期范围(区间)变量的选项值list
const dateRangeVariableList = ref([
  {
    label: '指定日期',
    value: 7
  },
  {
    label: '本周',
    value: 8
  },
  {
    label: '上周',
    value: 9
  },
  {
    label: '下周',
    value: 10
  },
  {
    label: '本月',
    value: 11
  },
  {
    label: '上月',
    value: 12
  },
  {
    label: '下月',
    value: 13
  },
  {
    label: '本季度',
    value: 14
  },
  {
    label: '上季度',
    value: 15
  },
  {
    label: '下季度',
    value: 16
  },
  {
    label: '今年',
    value: 17
  },
  {
    label: '去年',
    value: 18
  },
  {
    label: '明年',
    value: 19
  },
  {
    label: `过去${data.lastDay}天内`,
    value: 20
  },
  {
    label: `未来${data.nextDay}天内`,
    value: 21
  }
]);
console.log(data);

const handleBlur = () => {
  console.log('handleBlur');
  data.isPop = true;
  dateOverlay.value = true;
};

// 日期变量选择事件
const changeDateVariable = (value, type) => {
  console.log('788-1', value);
  const list = type === 1 ? dateVariableList.value : dateRangeVariableList.value;
  if (value === 1 || value === 7) {
    data.popupVisible = false;
    dateOverlayFun();
  } else if ([5, 20]?.includes(value)) {
    data.popupVisible = false;
    data.pickerValue = null;
    data.dateVariable = type === 1 ? [`过去第${data.lastDay}天`] : [`过去${data.lastDay}天内`];
    const params = { type: type === 1 ? 5 : 20, value: data.lastDay, dateVariable: data.dateVariable };
    console.log(183, params);
    emits('cb', JSON.stringify(params));
  } else if ([6, 21]?.includes(value)) {
    data.popupVisible = false;
    data.pickerValue = null;
    data.dateVariable = type === 1 ? [`未来第${data.nextDay}天`] : [`未来${data.nextDay}天内`];
    const params = { type: type === 1 ? 6 : 21, value: data.nextDay, dateVariable: data.dateVariable };
    console.log(183, params);
    emits('cb', JSON.stringify(params));
  } else {
    data.popupVisible = true;
    data.pickerValue = null;
    data.dateVariable = [list?.find((item) => item.value === value)?.label];
    const params = { type: value, value: null, dateVariable: data.dateVariable };
    console.log(183, params);
    dateOverlayFun();
    emits('cb', JSON.stringify(params));
  }
};
//删除变量
const removeDateVariable = () => {
  console.log('日期改变222');
  data.dateVariable = [];
  emits('cb', null);
};
// 指定日期选择事件
const changeDatePicker = (value, date) => {
  console.log('788-2', value, date);
  data.pickerVisible = false;
  data.popupVisible = true;
  data.dateVariable = value?.split(' ')?.length > 1 ? [dayjs(value).format('YYYY-MM-DD HH:mm')] : [value];
  // data.pickerValue = value;
  const params = { type: 1, value, dateVariable: data.dateVariable };
  dateOverlayFun();
  emits('cb', JSON.stringify(params));
};
// 指定日期范围变量
const changeDateRangePicker = (value, date) => {
  console.log('788-3', value, date);
  data.pickerVisible = false;
  data.popupVisible = true;
  data.dateVariable = value[0]?.split(' ')?.length > 1 ? [[dayjs(value[0]).format('YYYY-MM-DD HH:mm'), dayjs(value[1]).format('YYYY-MM-DD HH:mm')]] : [value];
  // data.pickerRangeValue = value;
  const params = { type: 7, value: { beginDate: value[0], endDate: value[1] }, dateVariable: data.dateVariable };
  dateOverlayFun();
  emits('cb', JSON.stringify(params));
};
// 选择过去第几天
const changeLastDay = (value, type) => {
  // data.popupVisible = true;
  console.log('changeLastDay', value, type);

  data.lastDay = value;
  if (!value) {
    data.lastDay = 1;
  }
  data.dateVariable = type === 1 ? [`过去第${data.lastDay}天`] : [`过去${data.lastDay}天内`];
  const params = { type: type === 1 ? 5 : 20, value: data.lastDay, dateVariable: data.dateVariable };
  emits('cb', JSON.stringify(params));
};
//选择未来第几天
const changeNextDay = (value, type) => {
  console.log(128, value);
  // data.popupVisible = true;
  data.nextDay = value;
  if (!value) {
    data.nextDay = 1;
  }
  data.dateVariable = type === 1 ? [`未来第${data.nextDay}天`] : [`未来${data.nextDay}天内`];
  const params = { type: type === 1 ? 6 : 21, value: data.nextDay, dateVariable: data.dateVariable };
  console.log(183, params);
  emits('cb', JSON.stringify(params));
};
watch(
  () => props.record,
  (v) => {
    console.log(270, v);
    if (!v?.value) {
      data.dateVariable = [];
    }
  },
  {
    deep: true,
    immediate: true
  }
);
</script>
<style scoped lang="less">
@import './xl-date-variable.less';
</style>

<style lang="less">
/******* 此处修改样式是为了让条件高度是默认高度（200px）同时让日期范围组件是不滚动的 */
.drop-down-date-range-picker {
  .arco-dropdown-list {
    max-height: 200px;
    overflow-y: scroll;
  }

  .my-variable-dropdown {
    padding: 0 8px;
    padding-right: 1px;

    .arco-dropdown-option {
      line-height: 32px;
    }
  }
}
</style>
